export default {
  data() {
    return {
      no_answer: [
        {
          id: 1,
          name: "users",
          alias: "users"
        }
      ]
    };
  }
};
